import dictionary from "./dictionary/dictionary.json";
// schedule ids
export const NON_CYLIC_SCHEDULE_ID = '255';
const eventIndex = (acronym) => dictionary.EventType.allowedValues[acronym];
export const CYCLIC_EVENTS = [
    eventIndex('FP'),
    eventIndex('PR'),
    eventIndex('PY'),
    eventIndex('IP'),
    eventIndex('IPCI'),
    eventIndex('RR'),
    eventIndex('SC'),
    eventIndex('COF'),
    eventIndex('COP'),
    eventIndex('REF'),
    eventIndex('REP'),
    eventIndex('EXE'),
];
export function isIP(obj) {
    if (!obj) {
        return false;
    }
    if (obj.i == undefined || (typeof obj.i !== 'number' && typeof obj.i !== 'string')) {
        return false;
    }
    if (obj.p == undefined || (typeof obj.p !== 'number' && typeof obj.p !== 'string')) {
        return false;
    }
    if (obj.isSet == undefined || typeof obj.isSet !== 'boolean') {
        return false;
    }
    return true;
}
export function isIPS(obj) {
    if (!obj) {
        return false;
    }
    if (obj.i == undefined || (typeof obj.i !== 'number' && typeof obj.i !== 'string')) {
        return false;
    }
    if (obj.p == undefined || (typeof obj.p !== 'number' && typeof obj.p !== 'string')) {
        return false;
    }
    if (obj.s == undefined || (typeof obj.s !== 'number' && typeof obj.s !== 'string')) {
        return false;
    }
    if (obj.isSet == undefined || typeof obj.isSet !== 'boolean') {
        return false;
    }
    return true;
}
export function isContractReference(obj) {
    if (!obj) {
        return false;
    }
    if (obj.object == undefined || typeof obj.object !== 'string') {
        return false;
    }
    if (obj._type == undefined
        || (typeof obj._type !== 'number' && typeof obj._type !== 'string')) {
        return false;
    }
    if (obj.role == undefined
        || (typeof obj.role !== 'number' && typeof obj.role !== 'string')) {
        return false;
    }
    return true;
}
export function isANNState(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractPerformance == undefined || typeof obj.contractPerformance !== 'number' && typeof obj.contractPerformance !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.nonPerformingDate == undefined || typeof obj.nonPerformingDate !== 'number' && typeof obj.nonPerformingDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.terminationDate == undefined || typeof obj.terminationDate !== 'number' && typeof obj.terminationDate !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.accruedInterest == undefined || typeof obj.accruedInterest !== 'number' && typeof obj.accruedInterest !== 'string') {
        return false;
    }
    if (obj.feeAccrued == undefined || typeof obj.feeAccrued !== 'number' && typeof obj.feeAccrued !== 'string') {
        return false;
    }
    if (obj.nominalInterestRate == undefined || typeof obj.nominalInterestRate !== 'number' && typeof obj.nominalInterestRate !== 'string') {
        return false;
    }
    if (obj.interestScalingMultiplier == undefined || typeof obj.interestScalingMultiplier !== 'number' && typeof obj.interestScalingMultiplier !== 'string') {
        return false;
    }
    if (obj.notionalScalingMultiplier == undefined || typeof obj.notionalScalingMultiplier !== 'number' && typeof obj.notionalScalingMultiplier !== 'string') {
        return false;
    }
    if (obj.nextPrincipalRedemptionPayment == undefined || typeof obj.nextPrincipalRedemptionPayment !== 'number' && typeof obj.nextPrincipalRedemptionPayment !== 'string') {
        return false;
    }
    return true;
}
export function isCECState(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractPerformance == undefined || typeof obj.contractPerformance !== 'number' && typeof obj.contractPerformance !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.nonPerformingDate == undefined || typeof obj.nonPerformingDate !== 'number' && typeof obj.nonPerformingDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.terminationDate == undefined || typeof obj.terminationDate !== 'number' && typeof obj.terminationDate !== 'string') {
        return false;
    }
    if (obj.feeAccrued == undefined || typeof obj.feeAccrued !== 'number' && typeof obj.feeAccrued !== 'string') {
        return false;
    }
    if (obj.exerciseAmount == undefined || typeof obj.exerciseAmount !== 'number' && typeof obj.exerciseAmount !== 'string') {
        return false;
    }
    return true;
}
export function isCEGState(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractPerformance == undefined || typeof obj.contractPerformance !== 'number' && typeof obj.contractPerformance !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.nonPerformingDate == undefined || typeof obj.nonPerformingDate !== 'number' && typeof obj.nonPerformingDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.terminationDate == undefined || typeof obj.terminationDate !== 'number' && typeof obj.terminationDate !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.feeAccrued == undefined || typeof obj.feeAccrued !== 'number' && typeof obj.feeAccrued !== 'string') {
        return false;
    }
    if (obj.exerciseAmount == undefined || typeof obj.exerciseAmount !== 'number' && typeof obj.exerciseAmount !== 'string') {
        return false;
    }
    return true;
}
export function isCERTFState(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractPerformance == undefined || typeof obj.contractPerformance !== 'number' && typeof obj.contractPerformance !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.nonPerformingDate == undefined || typeof obj.nonPerformingDate !== 'number' && typeof obj.nonPerformingDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.exerciseDate == undefined || typeof obj.exerciseDate !== 'number' && typeof obj.exerciseDate !== 'string') {
        return false;
    }
    if (obj.terminationDate == undefined || typeof obj.terminationDate !== 'number' && typeof obj.terminationDate !== 'string') {
        return false;
    }
    if (obj.lastCouponFixingDate == undefined || typeof obj.lastCouponFixingDate !== 'number' && typeof obj.lastCouponFixingDate !== 'string') {
        return false;
    }
    if (obj.exerciseAmount == undefined || typeof obj.exerciseAmount !== 'number' && typeof obj.exerciseAmount !== 'string') {
        return false;
    }
    if (obj.exerciseQuantity == undefined || typeof obj.exerciseQuantity !== 'number' && typeof obj.exerciseQuantity !== 'string') {
        return false;
    }
    if (obj.quantity == undefined || typeof obj.quantity !== 'number' && typeof obj.quantity !== 'string') {
        return false;
    }
    if (obj.couponAmountFixed == undefined || typeof obj.couponAmountFixed !== 'number' && typeof obj.couponAmountFixed !== 'string') {
        return false;
    }
    if (obj.marginFactor == undefined || typeof obj.marginFactor !== 'number' && typeof obj.marginFactor !== 'string') {
        return false;
    }
    if (obj.adjustmentFactor == undefined || typeof obj.adjustmentFactor !== 'number' && typeof obj.adjustmentFactor !== 'string') {
        return false;
    }
    return true;
}
export function isCOLLAState(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractPerformance == undefined || typeof obj.contractPerformance !== 'number' && typeof obj.contractPerformance !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.nonPerformingDate == undefined || typeof obj.nonPerformingDate !== 'number' && typeof obj.nonPerformingDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.terminationDate == undefined || typeof obj.terminationDate !== 'number' && typeof obj.terminationDate !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.accruedInterest == undefined || typeof obj.accruedInterest !== 'number' && typeof obj.accruedInterest !== 'string') {
        return false;
    }
    if (obj.nominalInterestRate == undefined || typeof obj.nominalInterestRate !== 'number' && typeof obj.nominalInterestRate !== 'string') {
        return false;
    }
    if (obj.interestScalingMultiplier == undefined || typeof obj.interestScalingMultiplier !== 'number' && typeof obj.interestScalingMultiplier !== 'string') {
        return false;
    }
    if (obj.notionalScalingMultiplier == undefined || typeof obj.notionalScalingMultiplier !== 'number' && typeof obj.notionalScalingMultiplier !== 'string') {
        return false;
    }
    return true;
}
export function isPAMState(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractPerformance == undefined || typeof obj.contractPerformance !== 'number' && typeof obj.contractPerformance !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.nonPerformingDate == undefined || typeof obj.nonPerformingDate !== 'number' && typeof obj.nonPerformingDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.terminationDate == undefined || typeof obj.terminationDate !== 'number' && typeof obj.terminationDate !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.accruedInterest == undefined || typeof obj.accruedInterest !== 'number' && typeof obj.accruedInterest !== 'string') {
        return false;
    }
    if (obj.feeAccrued == undefined || typeof obj.feeAccrued !== 'number' && typeof obj.feeAccrued !== 'string') {
        return false;
    }
    if (obj.nominalInterestRate == undefined || typeof obj.nominalInterestRate !== 'number' && typeof obj.nominalInterestRate !== 'string') {
        return false;
    }
    if (obj.interestScalingMultiplier == undefined || typeof obj.interestScalingMultiplier !== 'number' && typeof obj.interestScalingMultiplier !== 'string') {
        return false;
    }
    if (obj.notionalScalingMultiplier == undefined || typeof obj.notionalScalingMultiplier !== 'number' && typeof obj.notionalScalingMultiplier !== 'string') {
        return false;
    }
    return true;
}
export function isSTKState(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractPerformance == undefined || typeof obj.contractPerformance !== 'number' && typeof obj.contractPerformance !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.nonPerformingDate == undefined || typeof obj.nonPerformingDate !== 'number' && typeof obj.nonPerformingDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.exerciseDate == undefined || typeof obj.exerciseDate !== 'number' && typeof obj.exerciseDate !== 'string') {
        return false;
    }
    if (obj.terminationDate == undefined || typeof obj.terminationDate !== 'number' && typeof obj.terminationDate !== 'string') {
        return false;
    }
    if (obj.lastDividendFixingDate == undefined || typeof obj.lastDividendFixingDate !== 'number' && typeof obj.lastDividendFixingDate !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.exerciseAmount == undefined || typeof obj.exerciseAmount !== 'number' && typeof obj.exerciseAmount !== 'string') {
        return false;
    }
    if (obj.exerciseQuantity == undefined || typeof obj.exerciseQuantity !== 'number' && typeof obj.exerciseQuantity !== 'string') {
        return false;
    }
    if (obj.quantity == undefined || typeof obj.quantity !== 'number' && typeof obj.quantity !== 'string') {
        return false;
    }
    if (obj.couponAmountFixed == undefined || typeof obj.couponAmountFixed !== 'number' && typeof obj.couponAmountFixed !== 'string') {
        return false;
    }
    if (obj.marginFactor == undefined || typeof obj.marginFactor !== 'number' && typeof obj.marginFactor !== 'string') {
        return false;
    }
    if (obj.adjustmentFactor == undefined || typeof obj.adjustmentFactor !== 'number' && typeof obj.adjustmentFactor !== 'string') {
        return false;
    }
    if (obj.dividendPaymentAmount == undefined || typeof obj.dividendPaymentAmount !== 'number' && typeof obj.dividendPaymentAmount !== 'string') {
        return false;
    }
    if (obj.splitRatio == undefined || typeof obj.splitRatio !== 'number' && typeof obj.splitRatio !== 'string') {
        return false;
    }
    return true;
}
export function isTerms(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractType == undefined || typeof obj.contractType !== 'string' && typeof obj.contractType !== 'number') {
        return false;
    }
    if (obj.calendar == undefined || typeof obj.calendar !== 'string' && typeof obj.calendar !== 'number') {
        return false;
    }
    if (obj.contractRole == undefined || typeof obj.contractRole !== 'string' && typeof obj.contractRole !== 'number') {
        return false;
    }
    if (obj.dayCountConvention == undefined || typeof obj.dayCountConvention !== 'string' && typeof obj.dayCountConvention !== 'number') {
        return false;
    }
    if (obj.businessDayConvention == undefined || typeof obj.businessDayConvention !== 'string' && typeof obj.businessDayConvention !== 'number') {
        return false;
    }
    if (obj.endOfMonthConvention == undefined || typeof obj.endOfMonthConvention !== 'string' && typeof obj.endOfMonthConvention !== 'number') {
        return false;
    }
    if (obj.scalingEffect == undefined || typeof obj.scalingEffect !== 'string' && typeof obj.scalingEffect !== 'number') {
        return false;
    }
    if (obj.feeBasis == undefined || typeof obj.feeBasis !== 'string' && typeof obj.feeBasis !== 'number') {
        return false;
    }
    if (obj.creditEventTypeCovered == undefined || typeof obj.creditEventTypeCovered !== 'string' && typeof obj.creditEventTypeCovered !== 'number') {
        return false;
    }
    if (obj.couponType == undefined || typeof obj.couponType !== 'string' && typeof obj.couponType !== 'number') {
        return false;
    }
    if (obj.redeemableByIssuer == undefined || typeof obj.redeemableByIssuer !== 'string' && typeof obj.redeemableByIssuer !== 'number') {
        return false;
    }
    if (obj.currency == undefined || typeof obj.currency !== 'string') {
        return false;
    }
    if (obj.settlementCurrency == undefined || typeof obj.settlementCurrency !== 'string') {
        return false;
    }
    if (obj.collateralCurrency == undefined || typeof obj.collateralCurrency !== 'string') {
        return false;
    }
    if (obj.marketObjectCodeRateReset == undefined || typeof obj.marketObjectCodeRateReset !== 'string') {
        return false;
    }
    if (obj.marketObjectCodeOfCollateral == undefined || typeof obj.marketObjectCodeOfCollateral !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.initialExchangeDate == undefined || typeof obj.initialExchangeDate !== 'number' && typeof obj.initialExchangeDate !== 'string') {
        return false;
    }
    if (obj.issueDate == undefined || typeof obj.issueDate !== 'number' && typeof obj.issueDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.purchaseDate == undefined || typeof obj.purchaseDate !== 'number' && typeof obj.purchaseDate !== 'string') {
        return false;
    }
    if (obj.capitalizationEndDate == undefined || typeof obj.capitalizationEndDate !== 'number' && typeof obj.capitalizationEndDate !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfInterestPayment == undefined || typeof obj.cycleAnchorDateOfInterestPayment !== 'number' && typeof obj.cycleAnchorDateOfInterestPayment !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfRateReset == undefined || typeof obj.cycleAnchorDateOfRateReset !== 'number' && typeof obj.cycleAnchorDateOfRateReset !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfScalingIndex == undefined || typeof obj.cycleAnchorDateOfScalingIndex !== 'number' && typeof obj.cycleAnchorDateOfScalingIndex !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfFee == undefined || typeof obj.cycleAnchorDateOfFee !== 'number' && typeof obj.cycleAnchorDateOfFee !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfPrincipalRedemption == undefined || typeof obj.cycleAnchorDateOfPrincipalRedemption !== 'number' && typeof obj.cycleAnchorDateOfPrincipalRedemption !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfRedemption == undefined || typeof obj.cycleAnchorDateOfRedemption !== 'number' && typeof obj.cycleAnchorDateOfRedemption !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfTermination == undefined || typeof obj.cycleAnchorDateOfTermination !== 'number' && typeof obj.cycleAnchorDateOfTermination !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfCoupon == undefined || typeof obj.cycleAnchorDateOfCoupon !== 'number' && typeof obj.cycleAnchorDateOfCoupon !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfDividend == undefined || typeof obj.cycleAnchorDateOfDividend !== 'number' && typeof obj.cycleAnchorDateOfDividend !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.nominalPrice == undefined || typeof obj.nominalPrice !== 'number' && typeof obj.nominalPrice !== 'string') {
        return false;
    }
    if (obj.issuePrice == undefined || typeof obj.issuePrice !== 'number' && typeof obj.issuePrice !== 'string') {
        return false;
    }
    if (obj.quantity == undefined || typeof obj.quantity !== 'number' && typeof obj.quantity !== 'string') {
        return false;
    }
    if (obj.nominalInterestRate == undefined || typeof obj.nominalInterestRate !== 'number' && typeof obj.nominalInterestRate !== 'string') {
        return false;
    }
    if (obj.feeAccrued == undefined || typeof obj.feeAccrued !== 'number' && typeof obj.feeAccrued !== 'string') {
        return false;
    }
    if (obj.accruedInterest == undefined || typeof obj.accruedInterest !== 'number' && typeof obj.accruedInterest !== 'string') {
        return false;
    }
    if (obj.rateMultiplier == undefined || typeof obj.rateMultiplier !== 'number' && typeof obj.rateMultiplier !== 'string') {
        return false;
    }
    if (obj.rateSpread == undefined || typeof obj.rateSpread !== 'number' && typeof obj.rateSpread !== 'string') {
        return false;
    }
    if (obj.feeRate == undefined || typeof obj.feeRate !== 'number' && typeof obj.feeRate !== 'string') {
        return false;
    }
    if (obj.nextResetRate == undefined || typeof obj.nextResetRate !== 'number' && typeof obj.nextResetRate !== 'string') {
        return false;
    }
    if (obj.couponRate == undefined || typeof obj.couponRate !== 'number' && typeof obj.couponRate !== 'string') {
        return false;
    }
    if (obj.denominationRatio == undefined || typeof obj.denominationRatio !== 'number' && typeof obj.denominationRatio !== 'string') {
        return false;
    }
    if (obj.premiumDiscountAtIED == undefined || typeof obj.premiumDiscountAtIED !== 'number' && typeof obj.premiumDiscountAtIED !== 'string') {
        return false;
    }
    if (obj.priceAtPurchaseDate == undefined || typeof obj.priceAtPurchaseDate !== 'number' && typeof obj.priceAtPurchaseDate !== 'string') {
        return false;
    }
    if (obj.priceAtTerminationDate == undefined || typeof obj.priceAtTerminationDate !== 'number' && typeof obj.priceAtTerminationDate !== 'string') {
        return false;
    }
    if (obj.redemptionPrice == undefined || typeof obj.redemptionPrice !== 'number' && typeof obj.redemptionPrice !== 'string') {
        return false;
    }
    if (obj.nextPrincipalRedemptionPayment == undefined || typeof obj.nextPrincipalRedemptionPayment !== 'number' && typeof obj.nextPrincipalRedemptionPayment !== 'string') {
        return false;
    }
    if (obj.coverageOfCreditEnhancement == undefined || typeof obj.coverageOfCreditEnhancement !== 'number' && typeof obj.coverageOfCreditEnhancement !== 'string') {
        return false;
    }
    if (obj.coverageOfCollateral == undefined || typeof obj.coverageOfCollateral !== 'number' && typeof obj.coverageOfCollateral !== 'string') {
        return false;
    }
    if (obj.lifeCap == undefined || typeof obj.lifeCap !== 'number' && typeof obj.lifeCap !== 'string') {
        return false;
    }
    if (obj.lifeFloor == undefined || typeof obj.lifeFloor !== 'number' && typeof obj.lifeFloor !== 'string') {
        return false;
    }
    if (obj.periodCap == undefined || typeof obj.periodCap !== 'number' && typeof obj.periodCap !== 'string') {
        return false;
    }
    if (obj.periodFloor == undefined || typeof obj.periodFloor !== 'number' && typeof obj.periodFloor !== 'string') {
        return false;
    }
    if (!isIP(obj.gracePeriod)) {
        return false;
    }
    if (!isIP(obj.delinquencyPeriod)) {
        return false;
    }
    if (!isIP(obj.settlementPeriod)) {
        return false;
    }
    if (!isIP(obj.fixingPeriod)) {
        return false;
    }
    if (!isIP(obj.redemptionRecordPeriod)) {
        return false;
    }
    if (!isIP(obj.redemptionPaymentPeriod)) {
        return false;
    }
    if (!isIP(obj.dividendRecordPeriod)) {
        return false;
    }
    if (!isIP(obj.dividendPaymentPeriod)) {
        return false;
    }
    if (!isIP(obj.splitSettlementPeriod)) {
        return false;
    }
    if (!isIPS(obj.cycleOfInterestPayment)) {
        return false;
    }
    if (!isIPS(obj.cycleOfRateReset)) {
        return false;
    }
    if (!isIPS(obj.cycleOfScalingIndex)) {
        return false;
    }
    if (!isIPS(obj.cycleOfFee)) {
        return false;
    }
    if (!isIPS(obj.cycleOfPrincipalRedemption)) {
        return false;
    }
    if (!isIPS(obj.cycleOfRedemption)) {
        return false;
    }
    if (!isIPS(obj.cycleOfTermination)) {
        return false;
    }
    if (!isIPS(obj.cycleOfCoupon)) {
        return false;
    }
    if (!isIPS(obj.cycleOfDividend)) {
        return false;
    }
    if (!isContractReference(obj.contractReference_1)) {
        return false;
    }
    if (!isContractReference(obj.contractReference_2)) {
        return false;
    }
    return true;
}
export function isANNTerms(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractType == undefined || typeof obj.contractType !== 'string' && typeof obj.contractType !== 'number') {
        return false;
    }
    if (obj.calendar == undefined || typeof obj.calendar !== 'string' && typeof obj.calendar !== 'number') {
        return false;
    }
    if (obj.contractRole == undefined || typeof obj.contractRole !== 'string' && typeof obj.contractRole !== 'number') {
        return false;
    }
    if (obj.dayCountConvention == undefined || typeof obj.dayCountConvention !== 'string' && typeof obj.dayCountConvention !== 'number') {
        return false;
    }
    if (obj.businessDayConvention == undefined || typeof obj.businessDayConvention !== 'string' && typeof obj.businessDayConvention !== 'number') {
        return false;
    }
    if (obj.endOfMonthConvention == undefined || typeof obj.endOfMonthConvention !== 'string' && typeof obj.endOfMonthConvention !== 'number') {
        return false;
    }
    if (obj.scalingEffect == undefined || typeof obj.scalingEffect !== 'string' && typeof obj.scalingEffect !== 'number') {
        return false;
    }
    if (obj.feeBasis == undefined || typeof obj.feeBasis !== 'string' && typeof obj.feeBasis !== 'number') {
        return false;
    }
    if (obj.currency == undefined || typeof obj.currency !== 'string') {
        return false;
    }
    if (obj.settlementCurrency == undefined || typeof obj.settlementCurrency !== 'string') {
        return false;
    }
    if (obj.marketObjectCodeRateReset == undefined || typeof obj.marketObjectCodeRateReset !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.initialExchangeDate == undefined || typeof obj.initialExchangeDate !== 'number' && typeof obj.initialExchangeDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.issueDate == undefined || typeof obj.issueDate !== 'number' && typeof obj.issueDate !== 'string') {
        return false;
    }
    if (obj.purchaseDate == undefined || typeof obj.purchaseDate !== 'number' && typeof obj.purchaseDate !== 'string') {
        return false;
    }
    if (obj.capitalizationEndDate == undefined || typeof obj.capitalizationEndDate !== 'number' && typeof obj.capitalizationEndDate !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfInterestPayment == undefined || typeof obj.cycleAnchorDateOfInterestPayment !== 'number' && typeof obj.cycleAnchorDateOfInterestPayment !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfRateReset == undefined || typeof obj.cycleAnchorDateOfRateReset !== 'number' && typeof obj.cycleAnchorDateOfRateReset !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfScalingIndex == undefined || typeof obj.cycleAnchorDateOfScalingIndex !== 'number' && typeof obj.cycleAnchorDateOfScalingIndex !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfFee == undefined || typeof obj.cycleAnchorDateOfFee !== 'number' && typeof obj.cycleAnchorDateOfFee !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfPrincipalRedemption == undefined || typeof obj.cycleAnchorDateOfPrincipalRedemption !== 'number' && typeof obj.cycleAnchorDateOfPrincipalRedemption !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.nominalInterestRate == undefined || typeof obj.nominalInterestRate !== 'number' && typeof obj.nominalInterestRate !== 'string') {
        return false;
    }
    if (obj.accruedInterest == undefined || typeof obj.accruedInterest !== 'number' && typeof obj.accruedInterest !== 'string') {
        return false;
    }
    if (obj.rateMultiplier == undefined || typeof obj.rateMultiplier !== 'number' && typeof obj.rateMultiplier !== 'string') {
        return false;
    }
    if (obj.rateSpread == undefined || typeof obj.rateSpread !== 'number' && typeof obj.rateSpread !== 'string') {
        return false;
    }
    if (obj.nextResetRate == undefined || typeof obj.nextResetRate !== 'number' && typeof obj.nextResetRate !== 'string') {
        return false;
    }
    if (obj.feeRate == undefined || typeof obj.feeRate !== 'number' && typeof obj.feeRate !== 'string') {
        return false;
    }
    if (obj.feeAccrued == undefined || typeof obj.feeAccrued !== 'number' && typeof obj.feeAccrued !== 'string') {
        return false;
    }
    if (obj.premiumDiscountAtIED == undefined || typeof obj.premiumDiscountAtIED !== 'number' && typeof obj.premiumDiscountAtIED !== 'string') {
        return false;
    }
    if (obj.priceAtPurchaseDate == undefined || typeof obj.priceAtPurchaseDate !== 'number' && typeof obj.priceAtPurchaseDate !== 'string') {
        return false;
    }
    if (obj.priceAtTerminationDate == undefined || typeof obj.priceAtTerminationDate !== 'number' && typeof obj.priceAtTerminationDate !== 'string') {
        return false;
    }
    if (obj.nextPrincipalRedemptionPayment == undefined || typeof obj.nextPrincipalRedemptionPayment !== 'number' && typeof obj.nextPrincipalRedemptionPayment !== 'string') {
        return false;
    }
    if (obj.lifeCap == undefined || typeof obj.lifeCap !== 'number' && typeof obj.lifeCap !== 'string') {
        return false;
    }
    if (obj.lifeFloor == undefined || typeof obj.lifeFloor !== 'number' && typeof obj.lifeFloor !== 'string') {
        return false;
    }
    if (obj.periodCap == undefined || typeof obj.periodCap !== 'number' && typeof obj.periodCap !== 'string') {
        return false;
    }
    if (obj.periodFloor == undefined || typeof obj.periodFloor !== 'number' && typeof obj.periodFloor !== 'string') {
        return false;
    }
    if (!isIP(obj.gracePeriod)) {
        return false;
    }
    if (!isIP(obj.delinquencyPeriod)) {
        return false;
    }
    if (!isIPS(obj.cycleOfInterestPayment)) {
        return false;
    }
    if (!isIPS(obj.cycleOfRateReset)) {
        return false;
    }
    if (!isIPS(obj.cycleOfScalingIndex)) {
        return false;
    }
    if (!isIPS(obj.cycleOfFee)) {
        return false;
    }
    if (!isIPS(obj.cycleOfPrincipalRedemption)) {
        return false;
    }
    return true;
}
export function isCECTerms(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractType == undefined || typeof obj.contractType !== 'string' && typeof obj.contractType !== 'number') {
        return false;
    }
    if (obj.calendar == undefined || typeof obj.calendar !== 'string' && typeof obj.calendar !== 'number') {
        return false;
    }
    if (obj.contractRole == undefined || typeof obj.contractRole !== 'string' && typeof obj.contractRole !== 'number') {
        return false;
    }
    if (obj.dayCountConvention == undefined || typeof obj.dayCountConvention !== 'string' && typeof obj.dayCountConvention !== 'number') {
        return false;
    }
    if (obj.businessDayConvention == undefined || typeof obj.businessDayConvention !== 'string' && typeof obj.businessDayConvention !== 'number') {
        return false;
    }
    if (obj.endOfMonthConvention == undefined || typeof obj.endOfMonthConvention !== 'string' && typeof obj.endOfMonthConvention !== 'number') {
        return false;
    }
    if (obj.creditEventTypeCovered == undefined || typeof obj.creditEventTypeCovered !== 'string' && typeof obj.creditEventTypeCovered !== 'number') {
        return false;
    }
    if (obj.feeBasis == undefined || typeof obj.feeBasis !== 'string' && typeof obj.feeBasis !== 'number') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.feeRate == undefined || typeof obj.feeRate !== 'number' && typeof obj.feeRate !== 'string') {
        return false;
    }
    if (obj.coverageOfCreditEnhancement == undefined || typeof obj.coverageOfCreditEnhancement !== 'number' && typeof obj.coverageOfCreditEnhancement !== 'string') {
        return false;
    }
    if (!isContractReference(obj.contractReference_1)) {
        return false;
    }
    if (!isContractReference(obj.contractReference_2)) {
        return false;
    }
    return true;
}
export function isCEGTerms(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractType == undefined || typeof obj.contractType !== 'string' && typeof obj.contractType !== 'number') {
        return false;
    }
    if (obj.calendar == undefined || typeof obj.calendar !== 'string' && typeof obj.calendar !== 'number') {
        return false;
    }
    if (obj.contractRole == undefined || typeof obj.contractRole !== 'string' && typeof obj.contractRole !== 'number') {
        return false;
    }
    if (obj.dayCountConvention == undefined || typeof obj.dayCountConvention !== 'string' && typeof obj.dayCountConvention !== 'number') {
        return false;
    }
    if (obj.businessDayConvention == undefined || typeof obj.businessDayConvention !== 'string' && typeof obj.businessDayConvention !== 'number') {
        return false;
    }
    if (obj.endOfMonthConvention == undefined || typeof obj.endOfMonthConvention !== 'string' && typeof obj.endOfMonthConvention !== 'number') {
        return false;
    }
    if (obj.feeBasis == undefined || typeof obj.feeBasis !== 'string' && typeof obj.feeBasis !== 'number') {
        return false;
    }
    if (obj.creditEventTypeCovered == undefined || typeof obj.creditEventTypeCovered !== 'string' && typeof obj.creditEventTypeCovered !== 'number') {
        return false;
    }
    if (obj.currency == undefined || typeof obj.currency !== 'string') {
        return false;
    }
    if (obj.settlementCurrency == undefined || typeof obj.settlementCurrency !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.purchaseDate == undefined || typeof obj.purchaseDate !== 'number' && typeof obj.purchaseDate !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfFee == undefined || typeof obj.cycleAnchorDateOfFee !== 'number' && typeof obj.cycleAnchorDateOfFee !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.feeAccrued == undefined || typeof obj.feeAccrued !== 'number' && typeof obj.feeAccrued !== 'string') {
        return false;
    }
    if (obj.feeRate == undefined || typeof obj.feeRate !== 'number' && typeof obj.feeRate !== 'string') {
        return false;
    }
    if (obj.priceAtPurchaseDate == undefined || typeof obj.priceAtPurchaseDate !== 'number' && typeof obj.priceAtPurchaseDate !== 'string') {
        return false;
    }
    if (obj.coverageOfCreditEnhancement == undefined || typeof obj.coverageOfCreditEnhancement !== 'number' && typeof obj.coverageOfCreditEnhancement !== 'string') {
        return false;
    }
    if (!isIP(obj.gracePeriod)) {
        return false;
    }
    if (!isIP(obj.delinquencyPeriod)) {
        return false;
    }
    if (!isIPS(obj.cycleOfFee)) {
        return false;
    }
    if (!isContractReference(obj.contractReference_1)) {
        return false;
    }
    if (!isContractReference(obj.contractReference_2)) {
        return false;
    }
    return true;
}
export function isCERTFTerms(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractType == undefined || typeof obj.contractType !== 'string' && typeof obj.contractType !== 'number') {
        return false;
    }
    if (obj.calendar == undefined || typeof obj.calendar !== 'string' && typeof obj.calendar !== 'number') {
        return false;
    }
    if (obj.contractRole == undefined || typeof obj.contractRole !== 'string' && typeof obj.contractRole !== 'number') {
        return false;
    }
    if (obj.dayCountConvention == undefined || typeof obj.dayCountConvention !== 'string' && typeof obj.dayCountConvention !== 'number') {
        return false;
    }
    if (obj.businessDayConvention == undefined || typeof obj.businessDayConvention !== 'string' && typeof obj.businessDayConvention !== 'number') {
        return false;
    }
    if (obj.endOfMonthConvention == undefined || typeof obj.endOfMonthConvention !== 'string' && typeof obj.endOfMonthConvention !== 'number') {
        return false;
    }
    if (obj.couponType == undefined || typeof obj.couponType !== 'string' && typeof obj.couponType !== 'number') {
        return false;
    }
    if (obj.currency == undefined || typeof obj.currency !== 'string') {
        return false;
    }
    if (obj.settlementCurrency == undefined || typeof obj.settlementCurrency !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.initialExchangeDate == undefined || typeof obj.initialExchangeDate !== 'number' && typeof obj.initialExchangeDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.issueDate == undefined || typeof obj.issueDate !== 'number' && typeof obj.issueDate !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfRedemption == undefined || typeof obj.cycleAnchorDateOfRedemption !== 'number' && typeof obj.cycleAnchorDateOfRedemption !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfTermination == undefined || typeof obj.cycleAnchorDateOfTermination !== 'number' && typeof obj.cycleAnchorDateOfTermination !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfCoupon == undefined || typeof obj.cycleAnchorDateOfCoupon !== 'number' && typeof obj.cycleAnchorDateOfCoupon !== 'string') {
        return false;
    }
    if (obj.nominalPrice == undefined || typeof obj.nominalPrice !== 'number' && typeof obj.nominalPrice !== 'string') {
        return false;
    }
    if (obj.issuePrice == undefined || typeof obj.issuePrice !== 'number' && typeof obj.issuePrice !== 'string') {
        return false;
    }
    if (obj.quantity == undefined || typeof obj.quantity !== 'number' && typeof obj.quantity !== 'string') {
        return false;
    }
    if (obj.denominationRatio == undefined || typeof obj.denominationRatio !== 'number' && typeof obj.denominationRatio !== 'string') {
        return false;
    }
    if (obj.couponRate == undefined || typeof obj.couponRate !== 'number' && typeof obj.couponRate !== 'string') {
        return false;
    }
    if (!isIP(obj.gracePeriod)) {
        return false;
    }
    if (!isIP(obj.delinquencyPeriod)) {
        return false;
    }
    if (!isIP(obj.settlementPeriod)) {
        return false;
    }
    if (!isIP(obj.fixingPeriod)) {
        return false;
    }
    if (!isIP(obj.redemptionRecordPeriod)) {
        return false;
    }
    if (!isIPS(obj.cycleOfRedemption)) {
        return false;
    }
    if (!isIPS(obj.cycleOfTermination)) {
        return false;
    }
    if (!isIPS(obj.cycleOfCoupon)) {
        return false;
    }
    if (!isContractReference(obj.contractReference_1)) {
        return false;
    }
    if (!isContractReference(obj.contractReference_2)) {
        return false;
    }
    return true;
}
export function isCOLLATerms(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractType == undefined || typeof obj.contractType !== 'string' && typeof obj.contractType !== 'number') {
        return false;
    }
    if (obj.calendar == undefined || typeof obj.calendar !== 'string' && typeof obj.calendar !== 'number') {
        return false;
    }
    if (obj.contractRole == undefined || typeof obj.contractRole !== 'string' && typeof obj.contractRole !== 'number') {
        return false;
    }
    if (obj.dayCountConvention == undefined || typeof obj.dayCountConvention !== 'string' && typeof obj.dayCountConvention !== 'number') {
        return false;
    }
    if (obj.businessDayConvention == undefined || typeof obj.businessDayConvention !== 'string' && typeof obj.businessDayConvention !== 'number') {
        return false;
    }
    if (obj.endOfMonthConvention == undefined || typeof obj.endOfMonthConvention !== 'string' && typeof obj.endOfMonthConvention !== 'number') {
        return false;
    }
    if (obj.marketObjectCodeOfCollateral == undefined || typeof obj.marketObjectCodeOfCollateral !== 'string') {
        return false;
    }
    if (obj.currency == undefined || typeof obj.currency !== 'string') {
        return false;
    }
    if (obj.settlementCurrency == undefined || typeof obj.settlementCurrency !== 'string') {
        return false;
    }
    if (obj.collateralCurrency == undefined || typeof obj.collateralCurrency !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.initialExchangeDate == undefined || typeof obj.initialExchangeDate !== 'number' && typeof obj.initialExchangeDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.capitalizationEndDate == undefined || typeof obj.capitalizationEndDate !== 'number' && typeof obj.capitalizationEndDate !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfInterestPayment == undefined || typeof obj.cycleAnchorDateOfInterestPayment !== 'number' && typeof obj.cycleAnchorDateOfInterestPayment !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.nominalInterestRate == undefined || typeof obj.nominalInterestRate !== 'number' && typeof obj.nominalInterestRate !== 'string') {
        return false;
    }
    if (obj.accruedInterest == undefined || typeof obj.accruedInterest !== 'number' && typeof obj.accruedInterest !== 'string') {
        return false;
    }
    if (obj.premiumDiscountAtIED == undefined || typeof obj.premiumDiscountAtIED !== 'number' && typeof obj.premiumDiscountAtIED !== 'string') {
        return false;
    }
    if (obj.coverageOfCollateral == undefined || typeof obj.coverageOfCollateral !== 'number' && typeof obj.coverageOfCollateral !== 'string') {
        return false;
    }
    if (!isIP(obj.gracePeriod)) {
        return false;
    }
    if (!isIP(obj.delinquencyPeriod)) {
        return false;
    }
    if (!isIPS(obj.cycleOfInterestPayment)) {
        return false;
    }
    return true;
}
export function isPAMTerms(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractType == undefined || typeof obj.contractType !== 'string' && typeof obj.contractType !== 'number') {
        return false;
    }
    if (obj.calendar == undefined || typeof obj.calendar !== 'string' && typeof obj.calendar !== 'number') {
        return false;
    }
    if (obj.contractRole == undefined || typeof obj.contractRole !== 'string' && typeof obj.contractRole !== 'number') {
        return false;
    }
    if (obj.dayCountConvention == undefined || typeof obj.dayCountConvention !== 'string' && typeof obj.dayCountConvention !== 'number') {
        return false;
    }
    if (obj.businessDayConvention == undefined || typeof obj.businessDayConvention !== 'string' && typeof obj.businessDayConvention !== 'number') {
        return false;
    }
    if (obj.endOfMonthConvention == undefined || typeof obj.endOfMonthConvention !== 'string' && typeof obj.endOfMonthConvention !== 'number') {
        return false;
    }
    if (obj.scalingEffect == undefined || typeof obj.scalingEffect !== 'string' && typeof obj.scalingEffect !== 'number') {
        return false;
    }
    if (obj.feeBasis == undefined || typeof obj.feeBasis !== 'string' && typeof obj.feeBasis !== 'number') {
        return false;
    }
    if (obj.currency == undefined || typeof obj.currency !== 'string') {
        return false;
    }
    if (obj.settlementCurrency == undefined || typeof obj.settlementCurrency !== 'string') {
        return false;
    }
    if (obj.marketObjectCodeRateReset == undefined || typeof obj.marketObjectCodeRateReset !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.initialExchangeDate == undefined || typeof obj.initialExchangeDate !== 'number' && typeof obj.initialExchangeDate !== 'string') {
        return false;
    }
    if (obj.maturityDate == undefined || typeof obj.maturityDate !== 'number' && typeof obj.maturityDate !== 'string') {
        return false;
    }
    if (obj.issueDate == undefined || typeof obj.issueDate !== 'number' && typeof obj.issueDate !== 'string') {
        return false;
    }
    if (obj.purchaseDate == undefined || typeof obj.purchaseDate !== 'number' && typeof obj.purchaseDate !== 'string') {
        return false;
    }
    if (obj.capitalizationEndDate == undefined || typeof obj.capitalizationEndDate !== 'number' && typeof obj.capitalizationEndDate !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfInterestPayment == undefined || typeof obj.cycleAnchorDateOfInterestPayment !== 'number' && typeof obj.cycleAnchorDateOfInterestPayment !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfRateReset == undefined || typeof obj.cycleAnchorDateOfRateReset !== 'number' && typeof obj.cycleAnchorDateOfRateReset !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfScalingIndex == undefined || typeof obj.cycleAnchorDateOfScalingIndex !== 'number' && typeof obj.cycleAnchorDateOfScalingIndex !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfFee == undefined || typeof obj.cycleAnchorDateOfFee !== 'number' && typeof obj.cycleAnchorDateOfFee !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.nominalInterestRate == undefined || typeof obj.nominalInterestRate !== 'number' && typeof obj.nominalInterestRate !== 'string') {
        return false;
    }
    if (obj.accruedInterest == undefined || typeof obj.accruedInterest !== 'number' && typeof obj.accruedInterest !== 'string') {
        return false;
    }
    if (obj.rateMultiplier == undefined || typeof obj.rateMultiplier !== 'number' && typeof obj.rateMultiplier !== 'string') {
        return false;
    }
    if (obj.rateSpread == undefined || typeof obj.rateSpread !== 'number' && typeof obj.rateSpread !== 'string') {
        return false;
    }
    if (obj.nextResetRate == undefined || typeof obj.nextResetRate !== 'number' && typeof obj.nextResetRate !== 'string') {
        return false;
    }
    if (obj.feeRate == undefined || typeof obj.feeRate !== 'number' && typeof obj.feeRate !== 'string') {
        return false;
    }
    if (obj.feeAccrued == undefined || typeof obj.feeAccrued !== 'number' && typeof obj.feeAccrued !== 'string') {
        return false;
    }
    if (obj.premiumDiscountAtIED == undefined || typeof obj.premiumDiscountAtIED !== 'number' && typeof obj.premiumDiscountAtIED !== 'string') {
        return false;
    }
    if (obj.priceAtPurchaseDate == undefined || typeof obj.priceAtPurchaseDate !== 'number' && typeof obj.priceAtPurchaseDate !== 'string') {
        return false;
    }
    if (obj.priceAtTerminationDate == undefined || typeof obj.priceAtTerminationDate !== 'number' && typeof obj.priceAtTerminationDate !== 'string') {
        return false;
    }
    if (obj.lifeCap == undefined || typeof obj.lifeCap !== 'number' && typeof obj.lifeCap !== 'string') {
        return false;
    }
    if (obj.lifeFloor == undefined || typeof obj.lifeFloor !== 'number' && typeof obj.lifeFloor !== 'string') {
        return false;
    }
    if (obj.periodCap == undefined || typeof obj.periodCap !== 'number' && typeof obj.periodCap !== 'string') {
        return false;
    }
    if (obj.periodFloor == undefined || typeof obj.periodFloor !== 'number' && typeof obj.periodFloor !== 'string') {
        return false;
    }
    if (!isIP(obj.gracePeriod)) {
        return false;
    }
    if (!isIP(obj.delinquencyPeriod)) {
        return false;
    }
    if (!isIPS(obj.cycleOfInterestPayment)) {
        return false;
    }
    if (!isIPS(obj.cycleOfRateReset)) {
        return false;
    }
    if (!isIPS(obj.cycleOfScalingIndex)) {
        return false;
    }
    if (!isIPS(obj.cycleOfFee)) {
        return false;
    }
    return true;
}
export function isSTKTerms(obj) {
    if (!obj) {
        return false;
    }
    if (obj.contractType == undefined || typeof obj.contractType !== 'string' && typeof obj.contractType !== 'number') {
        return false;
    }
    if (obj.calendar == undefined || typeof obj.calendar !== 'string' && typeof obj.calendar !== 'number') {
        return false;
    }
    if (obj.contractRole == undefined || typeof obj.contractRole !== 'string' && typeof obj.contractRole !== 'number') {
        return false;
    }
    if (obj.dayCountConvention == undefined || typeof obj.dayCountConvention !== 'string' && typeof obj.dayCountConvention !== 'number') {
        return false;
    }
    if (obj.businessDayConvention == undefined || typeof obj.businessDayConvention !== 'string' && typeof obj.businessDayConvention !== 'number') {
        return false;
    }
    if (obj.endOfMonthConvention == undefined || typeof obj.endOfMonthConvention !== 'string' && typeof obj.endOfMonthConvention !== 'number') {
        return false;
    }
    if (obj.redeemableByIssuer == undefined || typeof obj.redeemableByIssuer !== 'string' && typeof obj.redeemableByIssuer !== 'number') {
        return false;
    }
    if (obj.currency == undefined || typeof obj.currency !== 'string') {
        return false;
    }
    if (obj.settlementCurrency == undefined || typeof obj.settlementCurrency !== 'string') {
        return false;
    }
    if (obj.statusDate == undefined || typeof obj.statusDate !== 'number' && typeof obj.statusDate !== 'string') {
        return false;
    }
    if (obj.issueDate == undefined || typeof obj.issueDate !== 'number' && typeof obj.issueDate !== 'string') {
        return false;
    }
    if (obj.purchaseDate == undefined || typeof obj.purchaseDate !== 'number' && typeof obj.purchaseDate !== 'string') {
        return false;
    }
    if (obj.cycleAnchorDateOfDividend == undefined || typeof obj.cycleAnchorDateOfDividend !== 'number' && typeof obj.cycleAnchorDateOfDividend !== 'string') {
        return false;
    }
    if (obj.nominalPrice == undefined || typeof obj.nominalPrice !== 'number' && typeof obj.nominalPrice !== 'string') {
        return false;
    }
    if (obj.notionalPrincipal == undefined || typeof obj.notionalPrincipal !== 'number' && typeof obj.notionalPrincipal !== 'string') {
        return false;
    }
    if (obj.issuePrice == undefined || typeof obj.issuePrice !== 'number' && typeof obj.issuePrice !== 'string') {
        return false;
    }
    if (obj.quantity == undefined || typeof obj.quantity !== 'number' && typeof obj.quantity !== 'string') {
        return false;
    }
    if (obj.priceAtPurchaseDate == undefined || typeof obj.priceAtPurchaseDate !== 'number' && typeof obj.priceAtPurchaseDate !== 'string') {
        return false;
    }
    if (obj.redemptionPrice == undefined || typeof obj.redemptionPrice !== 'number' && typeof obj.redemptionPrice !== 'string') {
        return false;
    }
    if (obj.priceAtTerminationDate == undefined || typeof obj.priceAtTerminationDate !== 'number' && typeof obj.priceAtTerminationDate !== 'string') {
        return false;
    }
    if (!isIP(obj.redemptionRecordPeriod)) {
        return false;
    }
    if (!isIP(obj.redemptionPaymentPeriod)) {
        return false;
    }
    if (!isIP(obj.dividendRecordPeriod)) {
        return false;
    }
    if (!isIP(obj.dividendPaymentPeriod)) {
        return false;
    }
    if (!isIP(obj.splitSettlementPeriod)) {
        return false;
    }
    if (!isIPS(obj.cycleOfDividend)) {
        return false;
    }
    return true;
}
//# sourceMappingURL=ACTUS.js.map